export const SETUP_APP = 'SETUP_APP';
export const SETUP_APP_COMPLETE = 'SETUP_APP_COMPLETE';
export const APP_STATE = 'APP_STATE';